import { Component, OnInit, Input } from '@angular/core';

import { DEFAULT_MENU } from '~common/config/menu';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  @Input() title: string;
  @Input() page: string;
  @Input() subMenu: string[];
  listSubMenu = [];

  constructor() { }

  ngOnInit(): void {
    if (this.subMenu) {
      this.setSubMenu();
    }
  }

  setSubMenu() {
    this.subMenu.map(item => {
      const el = {
        link: this.findMyLink(item),
        name: item
      };
      this.listSubMenu.push(el);
    });
  }

  findMyLink(name: string) {
    let item = DEFAULT_MENU;
  }
}
